/**
 *
 * Asynchronously loads the component for SocialHub
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const SocialHub = lazyLoad(
  () => import('./index'),
  module => module.SocialHub,
);
